import { FC } from "react";
import { TFunction } from "i18next";
import { useSeo } from "../../shared/components/UseSeoComponent";

interface ContactPageProps {
  maxWidth: number;
  screenWidth: number;
  screenHeight: number;
  t: TFunction<"translation", undefined>;
}

const ContactPage: FC<ContactPageProps> = (props: ContactPageProps) => {
  const { t, maxWidth, screenWidth } = props;
  useSeo("contactPage");
  return (
    <>
      <div className="container-fluid pb-5 mt-5 d-flex flex-column align-items-center justify-content-center">
        <div className="row mb-3" style={{ maxWidth: maxWidth }}>
          <div className="col-sm text-center">
            <h2>{t("contactPage.title")}</h2>
            <p>{t("contactPage.subtitle")}</p>
            <p>
              <strong>{t("contactPage.phoneLabel")} </strong>
              <a 
                href={`tel:${t("general.phoneNumber")}`}
                style={{ 
                  color: '#007bff', 
                  textDecoration: 'none',
                  fontWeight: '500'
                }}
                onMouseEnter={(e) => e.currentTarget.style.textDecoration = 'underline'}
                onMouseLeave={(e) => e.currentTarget.style.textDecoration = 'none'}
              >
                {t("general.phoneNumber")}
              </a>
            </p>
            <p>
              <strong>{t("contactPage.orLabel")}</strong>
            </p>
            <p>
              <strong>{t("contactPage.emailLabel")} </strong>
              <a 
                href={`mailto:${t("general.email")}`}
                style={{ 
                  color: '#007bff', 
                  textDecoration: 'none',
                  fontWeight: '500'
                }}
                onMouseEnter={(e) => e.currentTarget.style.textDecoration = 'underline'}
                onMouseLeave={(e) => e.currentTarget.style.textDecoration = 'none'}
              >
                {t("general.email")}
              </a>
            </p>
            <p style={{ marginTop: '2rem', fontSize: '0.9rem', color: '#6c757d' }}>
              {t("contactPage.address")}
            </p>
          </div>
        </div>
        <div className="row w-100" style={{ maxWidth: maxWidth }}>
          <div className="col-sm">
            <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1510.4169838529242!2d29.34674544021587!3d40.78766415685524!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14cade3db0538d99%3A0xbcdac64f407bbeca!2sBayramo%C4%9Flu%2C%2041700%20Dar%C4%B1ca%2FKocaeli!5e0!3m2!1str!2str!4v1752971672747!5m2!1str!2str" 
                title="address"
              allowFullScreen
              loading="lazy"
              className="w-100"
              style={{ height: "50vh" }}
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactPage;
